$(document).ready(function() {
  $(document).on('click', '.js_o-classicButton', function(e){
    e.preventDefault();

    if (!$(this).hasClass('disabled')) {
      var checkboxes = $(this).closest('form').find('input[type="radio"]');
      $(checkboxes[parseInt($(this).data('choose'))]).prop("checked", true);
      $(this).closest('form').submit();
    }
  });
});
